const PDFObject = require('pdfobject')

export const initPdfEmbed = function() {
  Array.from(document.querySelectorAll('.pdf-embed')).forEach(function(pdfEmbed) {
    PDFObject.embed(pdfEmbed.dataset.src, pdfEmbed);
  })
}
